module.exports = __webpack_public_path__ + "media/buchuhuo.47cbad68.mp3";